import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import ContactWrap from "./ContactWrap";

function ContaceUsPage() {
  return (
    <>
     <div className="background-image-unset bg-white">
    <Breadcrumb name="Contact Us" />
      <ContactWrap />
    </div>
      
    </>
  );
}

export default ContaceUsPage;
